import { createAction } from 'redux-actions';
import { http } from 'helpers/axios';
import assign from 'lodash/assign';
import axios from 'axios';
import fileDownload from 'js-file-download';
import { BASE_URL } from 'consts';

export const changeState = createAction('@@mam/changeState');

export const loading = createAction('@@mam/loading');

export const addAsset = createAction(
  '@@mam2/addAsset',
  (campaignId, file, thumb) => dispatch => {
    dispatch(loading());
    return http
      .post('/assets', {
        name: file.fileName,
        file: file._id,
        campaign: campaignId,
        global: false,
        thumb: thumb,
      })
      .get('data');
  }
);

export const fetchAssets = createAction(
  '@@mam2/fetchAssets',
  campaignId => (dispatch, getState) => {
    dispatch(loading());

    return Promise.all([
      // Get all assets for this campaign
      Promise.resolve(
        http.get(`/assets?query={"campaign":"${campaignId}"}`).get('data')
      ),
      // Get all global assets for this client
      http
        .get(
          `/assets?query={"client":"${
            getState().auth.user.client
          }", "global": true}`
        )
        .get('data'),
    ]).then(values => {
      const data = values
        // Concatenate all assets returned by promises
        .map(value => value.docs)
        // Avoid duplicates
        .reduce((acc, cur) => {
          cur.forEach(asset => {
            const found = acc.find(el => el._id === asset._id);
            if (!found) acc.push(asset);
          });
          return acc;
        }, []);
      return data;
    });
  }
);

export const fetchExperiences = createAction(
  '@@mam/fetchExperiences',
  campaignId => dispatch => {
    dispatch(loading());
    return http
      .get(
        `/assets?query={"campaign":"${campaignId}"}&populate=files&populate=package&pageSize=1000`
      )
      .get('data');
  }
);

export const selectExperience = createAction('@@mam/selectExperience');

export const deleteExperience = createAction(
  '@@mam/deleteExperience',
  experienceId => dispatch => {
    dispatch(loading());
    return http.delete(`/assets/${experienceId}`).get('data');
  }
);

export const experienceAdded = createAction(
  '@@mam/experienceAdded',
  experience => dispatch => {
    if (experience.package) {
      return http
        .get(`/files/${experience.package}`)
        .get('data')
        .then(data => assign(experience, { package: data }));
    } else {
      return Promise.all(
        experience.files.map(file => http.get(`/files/${file}`).get('data'))
      ).then(files => assign(experience, { files }));
    }
  }
);

export const deletePackage = createAction(
  '@@mam/deletePackage',
  experience => dispatch => {
    dispatch(loading());
    return http.delete(`/assets/${experience}`).get('data');
  }
);

export const deleteAsset = createAction(
  '@@mam/deleteAsset',
  experienceId => dispatch => {
    dispatch(loading());
    return http.delete(`/assets/${experienceId}`).get('data');
  }
);

export const updateProgress = createAction('@@mam/updateProgress');

export const downloadFile = createAction(
  '@@mam/downloadFile',
  (fileId, fileName, totalBytes) => (dispatch, getState) => {
    dispatch(loading());

    const download = axios.create({
      baseURL: BASE_URL,
      timeout: 3600000, // 1 hour
      headers: {
        authorization: getState().auth.token,
      },
      onDownloadProgress: progressEvent => {
        let percent = Math.round(
          (progressEvent.loaded * 100) / totalBytes || 100
        );
        // bug
        if (percent === Infinity) {
          percent = 0;
        }
        dispatch(updateProgress(percent));
      },
      responseType: 'blob', // <- if we remove this option, the download file gets corrupted
      xsrfCookieName: '_csrf',
      withCredentials: true,
    });

    return download
      .get(`/files/download/${fileId}`)
      .then(({ data }) => {
        return fileDownload(data, fileName);
      })
      .catch(error => {
        console.log(error);
      });
  }
);

export const updateComplianceStatus = createAction(
  '@@mam/updateComplianceStatus',
  campaignId => dispatch => {
    dispatch(loading());
    return http
      .get(
        `/assets?query={"campaign":"${campaignId}"}&fields=rows&fields=_id&fields=package&fields=status&fields=messages&pageSize=1000`
      )
      .get('data');
  }
);

export const add = createAction('@@mam/add');

export const cancel = createAction('@@mam/cancel');

export const clearMam = createAction('@@mam/clearMam');
